/**
 * Add your action types here.
 * @module constants/ActionTypes
 * @example
 * export const UPDATE_CONTENT = 'UPDATE_CONTENT';
 */

export const GET_SOCIAL_NETWORKS = 'GET_SOCIAL_NETWORKS';
export const GET_FOOTER_LINKS = 'GET_FOOTER_LINKS';
export const GET_AUTHOR = 'GET_AUTHOR';
